var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeslaIconHole(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#C90000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M512,0c282.8,0,512,229.2,512,512s-229.2,512-512,512S0,794.8,0,512S229.2,0,512,0z M511.5,872.4l89.9-506 c85.8,0,112.8,9.4,116.7,47.8c0,0,57.5-21.5,86.5-65c-113.2-52.4-227-54.8-227-54.8l-66.4,80.8h0.1L445,294.3 c0,0-113.8,2.4-227,54.8c29,43.5,86.5,65,86.5,65c3.9-38.4,30.9-47.8,116.1-47.9L511.5,872.4 M511.5,270.9 c91.5-0.8,196.2,14.1,303.5,60.9c14.4-25.8,18-37.1,18-37.1c-117.2-46.4-227-62.3-321.5-62.7c-94.6,0.4-204.4,16.3-321.5,62.7 c0,0,5.3,14,18,37.1C315.1,285.2,420,270.3,511.5,270.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeslaIconHole);
export default __webpack_public_path__ + "static/media/tesla_icon-hole.b3c7f9f53136b7d3052cca3c3c383a89.svg";
export { ForwardRef as ReactComponent };